import { Component, ViewChild } from '@angular/core';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs/internal/Subject';
import { CommonService } from '../Model/Common/common.service';
import { TooltipService } from '../Util/Tooltip/tooltip.service';
import { SessionService } from '../Util/Session/session.service';
import { Router, RouterModule } from '@angular/router';
import { ToastService, toastTypeEnum } from '../Util/Toast/toast.service';
import { ComboService } from '../Model/Combo/combo.service';
import { DownloadSampleService } from '../Model/DownloadSample/download-sample.service';
import { UtilityService } from '../Model/utility/utility.service';
import { CustomDateParserFormatter } from '../Util/DateFormat/date-format.service';
import { AttendanceEmployeeService } from '../Model/AttendanceEmployee/attendance-employee.service';
import { NgbDateParserFormatter, NgbDatepickerModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';

@Component({
  selector: 'app-track-attendance-back',
  standalone: true,
  imports: [CommonModule, NgSelectModule, RouterModule, DataTablesModule, FormsModule, LoaderComponent, NgbDatepickerModule],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
  templateUrl: './track-attendance-back.component.html',
  styleUrl: './track-attendance-back.component.scss'
})
export class TrackAttendanceBackComponent {

  isDisabled: boolean = false;
  user = [] as any;
  BranchMaster: any[] = [];
  ClientMaster: any[] = [];
  SiteMaster: any[] = [];
  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective
  dtTrigger: Subject<any> = new Subject<any>();
  TableDatas: any[] = []
  TableDatas2: any[] = []
  TableDatas3: any[] = []

  minToDate: any;
  maxToDate: any;

  minFromDate: any;
  maxFromDate: any;

  Filter = {
    SelectType: 'ED',
    PeriodFrom: null as any,
    PeriodTo: null as any,
    BranchId: null,
    ClientId: null,
    SiteId: null,
    DesignationId: null,
    EmpCode: null,
    EmpType: 'Back',
    EmpMasterId: null,
    AttendanceDate: null,

    UserId: null,

    FromDateObj: null as any,
    ToDateObj: null as any,
    //BranchId: null,
    // SiteId: null,
    // ClientId: null,
    //EmpType: null as any,
    //EmpCode: null,
    //EmpMasterId: null
  }

  constructor(
    protected common: CommonService,
    private tooltip: TooltipService,
    private session: SessionService,
    private router: Router,
    private toast: ToastService,
    private comboload: ComboService,
    private download: DownloadSampleService,
    private utility: UtilityService,
    private dateFormate: CustomDateParserFormatter,
    private empattendance: AttendanceEmployeeService,
    private modalService: NgbModal,
  ) {
    // this.common.getPageRights();
    this.user = this.session.GetUserDetails();
    //this.TypeData = this.route.snapshot.data['type']; // Will either be 'IDCard' or 'Biodata'
    // this.Filter.EmpType = this.router.url.split('/')[3];
    this.SelectDate('RegistrationDate', null, null);
  }
  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    this.isDisabled = true;
    this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          this.Filter.FromDateObj = this.dateFormate.parse(response.Table[0].RegistrationDate);
          this.Filter.ToDateObj = this.dateFormate.parse(response.Table[0].RegistrationDate);

          this.Filter.FromDateObj.day = 1;
          this.Filter.ToDateObj.day = parseInt(moment(response.Table[0].RegistrationDate).endOf('month').format('D'));
        }

        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
  ngOnInit(): void {
    this.ComboLoad('Branch');

  }
  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }
  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  ComboLoad(Combotype: String, Combotype2: string = '', index = 0) {
    this.isDisabled = true;
    this.comboload.ComboLoad({
      'Combotype': Combotype,
      'BranchId': (Combotype == 'Client') ? this.Filter.BranchId : 0,
      'ClientId': (Combotype == 'Site') ? this.Filter.ClientId : 0,
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Branch') {
          this.BranchMaster = response.ComboLoad;
        } else if (Combotype == 'Client') {
          this.ClientMaster = response.ComboLoad;
        } else if (Combotype == 'Site') {
          this.SiteMaster = response.ComboLoad;
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false
      },
    });
  }
  Validate(form: any) {
    if (form.valid) {
      if ((this.Filter.EmpCode === null || this.Filter.EmpCode === '') && (this.Filter.BranchId === null)) {
        this.toast.show({ message: 'Kindly choose either Branch or Employee Code.', type: toastTypeEnum.warning });
        return
      }
      this.Filter.UserId = this.user.UserId
      this.Filter.PeriodFrom = this.dateFormate.format(this.Filter.FromDateObj);
      this.Filter.PeriodTo = this.dateFormate.format(this.Filter.ToDateObj);
      this.isDisabled = true;
      this.expandedIndex = -1;
      this.subExpandedIndex = -1;
      this.TableDatas = []
      this.TableDatas2 = []
      this.TableDatas3 = []
      // this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      //   dtInstance.destroy();
      //   this.dtTrigger.next(null);
      // });
      this.empattendance.AttendanceEmployee(this.Filter).subscribe(
        (data: any) => {
          this.TableDatas = data.Table;
          if (this.TableDatas.length > 0) {
            this.TableDatas = Object.values(data.Table);
            // this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            //   dtInstance.destroy();
            //   this.dtTrigger.next(null);
            // });
            this.isDisabled = false
          }
          else {
            this.toast.show({ message: 'No Data Found!', type: toastTypeEnum.warning });
            this.isDisabled = false
          }
        });
    }
    else {
      form.submitted = true;
    }
  }

  onSelectChange(type: string) {
    if (type === 'Branch') {
      this.Filter.ClientId = null
      this.ClientMaster = [];
      this.Filter.SiteId = null
      this.SiteMaster = []
      this.TableDatas = []
      this.TableDatas2 = []
      this.TableDatas3 = []
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } else if (type === 'Client') {
      this.Filter.SiteId = null
      this.SiteMaster = []
      this.TableDatas = [];
      this.TableDatas2 = []
      this.TableDatas3 = []
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } else if (type === 'Site') {
      this.TableDatas = [];
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } else if (type === 'from') {
      this.TableDatas = [];
      this.TableDatas2 = []
      this.TableDatas3 = []
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } else if (type === 'to') {
      this.TableDatas = [];
      this.TableDatas2 = []
      this.TableDatas3 = []
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    }
  }

  // onViewClick1(element: any) {
  //   this.Filter.PeriodFrom = this.dateFormate.format(this.Filter.FromDateObj);
  //   this.Filter.PeriodTo = this.dateFormate.format(this.Filter.ToDateObj);
  //   const modalRef = this.modalService.open(AttendanceEmpDetailComponent, { centered: true, backdrop: 'static', size: 'xl' });
  //   modalRef.componentInstance.InputData = {
  //     SelectType: 'AD',
  //     PeriodFrom: this.Filter.PeriodFrom,
  //     PeriodTo: this.Filter.PeriodTo,
  //     BranchId: element.BranchId,
  //     ClientId: element.ClientId,
  //     SiteId: element.SiteId,
  //     DesignationId: element.DesignationId,
  //     EmpCode: element.EmpCode,
  //     EmpType: null,
  //     EmpMasterId: element.EmpMasterID,
  //     AttendanceDate: null,
  //     UserId: this.user.UserId,
  //     Photo: element.Photo,
  //     EmpName: element.EmpName,
  //     DesignationName: element.DesignationName
  //   };
  //   modalRef.result.then((result) => {
  //     if (result) {
  //     }
  //   }).catch((reason) => {
  //     console.log('Modal dismissed:', reason);
  //   });
  // }

  onFromDateChange() {
    if (this.Filter.FromDateObj) {
      const from = this.Filter.FromDateObj;
      const fromDate = new Date(from.year, from.month - 1, from.day);

      // Set max date = fromDate + 1 month
      const maxTo = new Date(fromDate);
      maxTo.setMonth(maxTo.getMonth() + 1);

      this.minToDate = { ...from };
      this.maxToDate = {
        year: maxTo.getFullYear(),
        month: maxTo.getMonth() + 1,
        day: maxTo.getDate()
      };

      // Reset invalid ToDate
      if (this.Filter.ToDateObj) {
        const to = this.Filter.ToDateObj;
        const toDate = new Date(to.year, to.month - 1, to.day);
        const diff = (toDate.getTime() - fromDate.getTime()) / (1000 * 3600 * 24);
        if (diff < 0 || diff > 31) {
          this.Filter.ToDateObj = null;
        }
      }
    }
  }

  onToDateChange() {
    if (this.Filter.ToDateObj) {
      const to = this.Filter.ToDateObj;
      const toDate = new Date(to.year, to.month - 1, to.day);

      const minFrom = new Date(toDate);
      minFrom.setMonth(minFrom.getMonth() - 1);

      this.maxFromDate = { ...to };
      this.minFromDate = {
        year: minFrom.getFullYear(),
        month: minFrom.getMonth() + 1,
        day: minFrom.getDate()
      };

      // Reset invalid FromDate
      if (this.Filter.FromDateObj) {
        const from = this.Filter.FromDateObj;
        const fromDate = new Date(from.year, from.month - 1, from.day);
        const diff = (toDate.getTime() - fromDate.getTime()) / (1000 * 3600 * 24);
        if (diff < 0 || diff > 31) {
          this.Filter.FromDateObj = null;
        }
      }
    }
  }

  expandedIndex: number = -1;
  subExpandedIndex: number = -1;

  onViewClick(element: any, i: number) {
    this.expandedIndex = (this.expandedIndex === i) ? -1 : i;
    this.subExpandedIndex = -1;
    const data = {
      SelectType: 'AD',
      PeriodFrom: this.Filter.PeriodFrom,
      PeriodTo: this.Filter.PeriodTo,
      BranchId: element.BranchId,
      ClientId: element.ClientId,
      SiteId: element.SiteId,
      DesignationId: element.DesignationId,
      EmpCode: element.EmpCode,
      EmpType: null,
      EmpMasterId: element.EmpMasterID,
      AttendanceDate: null,
      UserId: this.user.UserId,
      Photo: element.Photo,
      EmpName: element.EmpName,
      DesignationName: element.DesignationName
    }
    this.isDisabled = true
    this.empattendance.AttendanceEmployee(data).subscribe(
      (data: any) => {
        this.isDisabled = false
        this.TableDatas2 = data.Table;
        if (this.TableDatas2.length > 0) {
          this.TableDatas2 = Object.values(data.Table);
          this.isDisabled = false
        }
        this.isDisabled = false
      });
  }

  onSubViewClick(element: any, i: number, element1: any) {
    this.subExpandedIndex = (this.subExpandedIndex === i) ? -1 : i;
    const data = {
      SelectType: 'DA',
      PeriodFrom: this.Filter.PeriodFrom,
      PeriodTo: this.Filter.PeriodTo,
      BranchId: element.BranchId,
      ClientId: element.ClientId,
      SiteId: element.SiteId,
      DesignationId: element.DesignationId,
      EmpCode: element1.EmpCode,
      EmpType: null,
      EmpMasterId: element1.EmpMasterID,
      AttendanceDate: element1.AttendanceDate,
      UserId: this.user.UserId,
      Photo: element.Photo,
      EmpName: element.EmpName,
      DesignationName: element.DesignationName
    }
    this.isDisabled = true
    this.empattendance.AttendanceEmployee(data).subscribe(
      (data: any) => {
        this.isDisabled = false
        this.TableDatas3 = data.Table;
        if (this.TableDatas3.length > 0) {
          this.TableDatas3 = Object.values(data.Table);
          this.isDisabled = false
        }
        this.isDisabled = false
      });
  }

  // getAttendanceDetails(empId: number) {
  //   return [
  //     {
  //       AttendanceDate: new Date(),
  //       InTime: new Date(),
  //       OutTime: new Date(),
  //       AttendanceType: 'Present',
  //       WorkingHour: '8:00',
  //       ShiftTitle: 'Morning',
  //       ShiftStart: '09:00',
  //       ShiftEnd: '17:00',
  //       PunchDetails: [
  //         {
  //           Time: new Date(),
  //           AttendanceStatus: 'P',
  //           PunchedThrough: 'App',
  //         }
  //       ]
  //     }
  //   ];
  // }

  clear() {
    this.TableDatas = []
    this.TableDatas2 = []
    this.TableDatas3 = []
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }

}
